import { PageStyle } from './page-style.model';

export class HostedPaymentRequest {
  AuthorizationCode: string;
  IsValid: boolean;
  IsExpired: boolean;
  IsCompleted: boolean;
  IsInProgress: boolean;
  Amount: number;
  CurrencyCode: string;
  CreditorName: string;
  Description: string;
  CreatedAt: Date;
  ExpirationDate: Date;
  TransactionId: string;
  RedirectUrl: string;
  PageStyle: PageStyle;
}

export class HostedPaymentRequestStart {
  CountryId: string;
  BankId: string;
  AdditionalFields: {[key: string]: string};
}

export class HostedPaymentRequestStartResponse {
  UiUrlRedirect: string;
}

export class HostedPaymentCountry {
  Id: string;
  Name: string;
}

export class HostedPaymentBank {
  BankId: string;
  Name: string;
  Services: string[];
  FlowDefinitions: {[key: string]: HostedPaymentBankFlowDefinition};
  Bic: string[];
}

export class HostedPaymentBankFlowDefinition {
  Specification: HostedPaymentBankFlowDefinitionSpecification;
  RequiredData: {[key: string]: HostedPaymentBankFlowDefinitionRequiredDataField};
}

export class HostedPaymentBankFlowDefinitionSpecification {
  AvailableModes: string[];
}

export class HostedPaymentBankFlowDefinitionRequiredDataField {
  Name: string;
  DisplayName: string;
  Label: string;
  FieldEnum: string;
  DefaultValue: string;
  DefaultAvailableValues: string[];
  Description: string;
  Required: boolean;
}
